import { useCallback } from 'react';

import { CONTENT_IMAGE } from 'global/constants';
import { useActivityBuilderContext } from 'approot/activity-builder/activity-builder.context';
import { IMAGE_FILE_KEY_FIELD } from 'approot/shared/stimulus/form-fields/stimulus-form-fields.constants';
import { Props } from './image.constants';
import {
  useAddImageToComponent,
  useFindComponentDimensions,
} from '../component.hooks';
import { FileDropperContextProvider } from 'lib/form/file-dropper/file-dropper';
import * as Styled from './image.style';
import { FileDropperImage } from 'lib/form/file-dropper/file-dropper-image';
import { ACCEPT_TYPE_IMAGE } from 'lib/form/file-dropper/file-dropper.constants';
import { useGetInteractiveLessonParams } from 'approot/activity-builder/activity-builder.hooks';

const ImageCreate = (props: Props) => {
  const { id, sectionId, contentId } = props;
  const { openDrawer, setActiveComponent } = useActivityBuilderContext();
  const { contentType } = useGetInteractiveLessonParams();
  const { elementDimensionLabel } = useFindComponentDimensions(props.id);

  const { addImageToComponent, loading } = useAddImageToComponent();

  const handleFileChange = useCallback(
    (key: string, fileName: string) => {
      addImageToComponent({
        variables: {
          input: {
            contentId,
            contentType,
            sectionId,
            componentId: id,
            imageInput: {
              key,
              imageType: CONTENT_IMAGE,
              data: {
                flip: null,
              },
              fileName,
            },
          },
        },
      });
    },
    [id, contentId, sectionId, addImageToComponent, contentType]
  );

  return (
    <FileDropperContextProvider>
      <Styled.ImageCreateFieldWrapper>
        <FileDropperImage
          name={IMAGE_FILE_KEY_FIELD}
          inputDataSelector={IMAGE_FILE_KEY_FIELD}
          accept={[ACCEPT_TYPE_IMAGE]}
          onChange={handleFileChange}
          isFinishing={loading}
          additionalLabel={elementDimensionLabel}
          additionalButton={{
            text: 'More Options',
            onClick: () => {
              setActiveComponent({ id });
              openDrawer({
                componentId: props.id,
              });
            },
          }}
        />
      </Styled.ImageCreateFieldWrapper>
    </FileDropperContextProvider>
  );
};

export default ImageCreate;
